import './components'
import KrealabModal from "./elements/KrealabModal";
import KrealabAjaxForm from './elements/KrealabAjaxForm';

new KrealabModal();

jQuery(function($){
    new KrealabAjaxForm($);
});